// extracted by mini-css-extract-plugin
export default {"my_select_wrapper":"CustomSelectWithMui_my_select_wrapper__KPhou","my_select":"CustomSelectWithMui_my_select__NZDfM","label":"CustomSelectWithMui_label__RlY7y"};